module.exports = __webpack_public_path__ + "img/diente3.2fb18716.svg";